import { forwardRef } from "react";
import Container from "../Container";
import * as S from "./styles";

type Props = {
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
};

const CustomCheckbox = forwardRef<HTMLInputElement, Props>(
  ({ onChange, checked, label, disabled, indeterminate }, ref) => {
    return (
      <Container padding="0" gap={1} flat>
        <S.CheckboxWrapper className={disabled ? "disabled" : ""}>
          <S.CheckboxInput
            ref={ref}
            type="checkbox"
            onChange={onChange}
            checked={checked}
            disabled={disabled}
            data-indeterminate={indeterminate}
          />
          <S.Checkmark>
            <S.CheckmarkTick />
            <S.CheckmarkIndeterminate />
          </S.Checkmark>
        </S.CheckboxWrapper>
        {label && <S.CheckboxLabel>{label}</S.CheckboxLabel>}
      </Container>
    );
  }
);

CustomCheckbox.displayName = "CustomCheckbox";

export default CustomCheckbox;
